import React from 'react';
import PropTypes from 'prop-types';
import { FormattedMessage } from 'react-intl';
import { CustomRadioField, CustomSelectField } from '../../../components';
import formUtils from '../../../utils/formUtils';

function DischargeSection({ militaryEnums, collected_attributes, intl }) {
  return (
    <>
      {collected_attributes.military_discharge_type && (
        <CustomSelectField
          name="military.discharge_type"
          id="uu_contact_military_discharge_type"
          label={<FormattedMessage id="G4Oq5T" description="militaryDischarge" defaultMessage="Military Discharge" />}
          options={formUtils.translateOptions(intl, militaryEnums.discharge_type)}
        />
      )}
      {collected_attributes.military_discharged_due_to_disability && (
        <CustomRadioField
          name="military.discharged_due_to_disability"
          label={<FormattedMessage id="2pCvO5" description="dischargedOrRetiredForDisability" defaultMessage="Discharged or retired from military service for a disability incurred in the line of duty?" />}
          id="uu_contact_military_discharged_due_to_disability"
          options={formUtils.translateOptions(intl, militaryEnums.discharge_disability)}
        />
      )}
    </>
  );
}

DischargeSection.propTypes = {
  militaryEnums: PropTypes.object.isRequired,
  collected_attributes: PropTypes.object.isRequired,
  intl: PropTypes.object.isRequired,
};

export default DischargeSection;
